export const supervisoryMenuItems = [
  {
    key: '0',
    path: '/FileUpload',
    icon: 'upload',
    label: '更新檔上傳'
  },
  {
    key: '1',
    path: '/UploadOTA',
    icon: 'cluster',
    label: '更新檔發布'
  },
  {
    key: '2',
    path: '/DeviceList',
    icon: 'profile',
    label: '裝置列表'
  },
  {
    key: '3',
    path: '/GetLogFile',
    icon: 'file-text',
    label: '取得log檔'
  },
  {
    key: '4',
    path: '/ScreenShot',
    icon: 'camera',
    label: '螢幕截圖'
  },
  {
    key: '5',
    path: '/AlarmList',
    icon: 'bar-chart',
    label: '警告列表'
  },
  {
    key: '6',
    path: '/CheckProperties',
    icon: 'setting',
    label: '查看設定檔'
  },
  {
    key: '7',
    path: '/Suspend',
    icon: 'history',
    label: '暫停營運'
  },
  {
    key: '8',
    path: '/HardwareControl',
    icon: 'control',
    label: '硬體功能'
  }
]

export const supervisoryRoutePaths = supervisoryMenuItems.map(item => item.path)
